export class DocumentModel {
  image: string;
}
